import { render, staticRenderFns } from "./completionRate.vue?vue&type=template&id=bd8bfe7a&scoped=true"
import script from "./completionRate.vue?vue&type=script&lang=js"
export * from "./completionRate.vue?vue&type=script&lang=js"
import style0 from "./completionRate.vue?vue&type=style&index=0&id=bd8bfe7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8bfe7a",
  null
  
)

export default component.exports